import Client from './axiosClient'
const resource = '/partners_bank_accounts';
const resourceInit = '/bank_initialize';
const resourceStoreActiveBankData = '/active_account';

export default {
  init() {
    return Client.get(`${resourceInit}`);
  },
  get() {
    return Client.get(`${resource}`);
  },

  getById(id) {
    return Client.get(`${resource}/${id}`);
  },

  post(payload) {
    return Client.post(`${resource}`, payload);
  },
  postActiveBankData(payload) {
    return Client.post(`${resourceStoreActiveBankData}`, payload);
  },

};



// WEBPACK FOOTER //
// ./src/repositories/partnersBankAccountsRepository.js